import { Injectable } from '@angular/core';
import PouchDB from 'pouchdb';
import PouchFind from 'pouchdb-find';
import cordovaSqlitePlugin from 'pouchdb-adapter-cordova-sqlite';

import { Arbitros, Actas_ConfirmarAlineaciones } from '../../models/arbitros';
import { CodigosAmonestacion_API } from '../../models/codigosAmonestacion';
import { Comites_API } from '../../models/comites';
import { Designaciones_API, TipoLicenciaMin } from '../../models/designaciones';
import { LicenciasPorEquipo_Value } from '../../models/licencias';
import { Images_Value } from "../../models/fotos";
import { ActaCustodiaMin } from '../../models/custodia';
import { iLogs } from '../../models/basePage';

import { Online } from '../../models/online/cfutbol';

// #region Interfaces con las clases de la API

export interface iActas_ConfirmarAlineaciones extends Actas_ConfirmarAlineaciones {
  _id: string;
  _rev?: string;
  type: string;
}

export interface iActaCustodiaMin extends ActaCustodiaMin {
  _id: string;
  _rev?: string;
  type: string;
}

export interface iArbitros extends Arbitros {
  _id: string;
  _rev?: string;
  type: string;
}

export interface iCodigosAmonestacion extends CodigosAmonestacion_API {
  _id: string;
  _rev?: string;
  type: string;
}

export interface iComites extends Comites_API {
  _id: string;
  _rev?: string;
  type: string;
}

export interface iDesignacionesAPI extends Designaciones_API {
  _id: string;
  _rev?: string;
  type: string;
  idUsuario: number;
}

export interface iFotos extends Images_Value {
  _id: string;
  _rev?: string;
  type: string;
}

export interface iLicencias extends LicenciasPorEquipo_Value {
  _id: string;
  _rev?: string;
  type: string;
}

export interface iTipoLicenciaMin extends TipoLicenciaMin {
  _id: string;
  _rev?: string;
  type: string;
}
// #endregion

// #region pouchdb VERSIÓN 1
export namespace pouchdb {

  @Injectable()
  export class DBService {
    private _db: PouchDB.Database;
    public static _nombreTablaConfirmarAlineaciones: string = "CONFIRMAR_ALINEACIONES";
    public static _nombreTablaCustodias: string = "CUSTODIAS_V2";
    private static _nombreTableLogs: string = "LOGS";

    // #region Operaciones directas con la base de datos

    /**
     * Inicializa la base de datos
     */
    public initDB(): void {
      PouchDB.plugin(cordovaSqlitePlugin);
      PouchDB.plugin(PouchFind);
      //this._db = new PouchDB('CFutbolActas.db', { adapter: 'cordova-sqlite' });
      this._db = new PouchDB('CFutbolActas.db', { adapter: 'websql' });
      console.log("Base de datos inicializada");
      this._db.info()
        .then((resultado: any) => {
          console.log(resultado);
        })
        .catch(error => console.error(error));
    }

    /**
     * Elimina la base de datos y la vuelve a crear
     */
    public destroy(): Promise<void> {
      return this._db.destroy()
        .then(() => {
          return this.initDB();
        });
    }

    // #endregion

    // #region CODIGOSAMONESTACION

    CodigosAmonestacionConversion(datos: CodigosAmonestacion_API): iCodigosAmonestacion {
      let nuevo: iCodigosAmonestacion = <iCodigosAmonestacion>datos;
      nuevo._id = '';
      nuevo._rev = '';
      nuevo.type = 'CODIGOSAMONESTACION';
      return nuevo;
    }

    CodigosAmonestacionCreateAll(datos: Array<CodigosAmonestacion_API>): Promise<PouchDB.Core.Response[]> {
      let aux: Array<Promise<PouchDB.Core.Response>> = [];

      datos.forEach((valor: CodigosAmonestacion_API, i: number) => {
        let nuevo: iCodigosAmonestacion = this.CodigosAmonestacionConversion(valor);

        nuevo._id = new Date().getTime() + '_' + nuevo.id.toString();
        nuevo._rev = '';
        nuevo.type = 'CODIGOSAMONESTACION';

        aux.push(this._db.put(nuevo));
      });

      return Promise.all(aux);
    }

    CodigosAmonestacionGelAll(): Promise<PouchDB.Find.FindResponse<any>> {
      return this._db.find({
        selector: {
          type: 'CODIGOSAMONESTACION'
        }
      });
    }

    CodigosAmonestacionDeleteAll(): Promise<boolean> {
      return this._db.find({
        selector: {
          type: 'CODIGOSAMONESTACION'
        }
      })
        .then((resultado: PouchDB.Find.FindResponse<iCodigosAmonestacion>) => {
          if (resultado.docs != null && resultado.docs.length > 0) {
            let aux: Array<Promise<PouchDB.Core.Response>> = [];

            resultado.docs.forEach((valor: PouchDB.Core.Document<iCodigosAmonestacion>, i: number) => {
              aux.push(this._db.remove(valor._id, valor._rev));
            });

            return Promise.all(aux);
          }
        })
        .then((resultado) => {
          return Promise.resolve(true);
        })
        .catch((error) => {
          return Promise.reject(false);
        });
    }

    // #endregion

    // #region COMITES

    ComitesConversion(datos: Comites_API): iComites {
      let nuevo: iComites = <iComites>datos;
      nuevo._id = '';
      nuevo._rev = '';
      nuevo.type = 'COMITES';
      return nuevo;
    }

    ComitesGetAll(): Promise<PouchDB.Find.FindResponse<any>> {
      return this._db.find({
        selector: {
          type: 'COMITES'
        }
      });
    }

    // #endregion

    // #region CONFIRMAR_ALINEACIONES

    /**
     * Devuelve una instancia de esta clase, conviertiendo los datos pasados como parámetro
     *
     * @param {Actas_ConfirmarAlineaciones} datos   Datos a convertir
     * @param {string} [_id=""]   Identificador de la nueva instancia
     * @param {string} [_rev=""]  Revisón de la nueva instancia
     * @returns {iActas_ConfirmarAlineaciones}  Instancia de la clase con los datos convertidos
     * @memberof DBService
     */
    ConfirmarAlineaciones_Conversion(datos: Actas_ConfirmarAlineaciones, _id: string = "", _rev: string = ""): iActas_ConfirmarAlineaciones {
      let nuevo: iActas_ConfirmarAlineaciones = <iActas_ConfirmarAlineaciones>datos;
      nuevo._id = _id;
      nuevo._rev = _rev;
      nuevo.type = DBService._nombreTablaConfirmarAlineaciones;
      return nuevo;
    }

    /**
     * Crea el registro en la base de datos local correspondiente a los datos pasados como parámetros
     *
     * @param {Actas_ConfirmarAlineaciones} datos  Datos a guardar
     * @param {number} idDesignacion  Identificador de la designación asociada
     * @returns {Promise<iActas_ConfirmarAlineaciones>}  Registro guardado en la base de datos
     * @memberof DBService
     */
    ConfirmarAlineaciones_Create(datos: Actas_ConfirmarAlineaciones, idDesignacion: number): Promise<iActas_ConfirmarAlineaciones> {
      let nuevo: iActas_ConfirmarAlineaciones = this.ConfirmarAlineaciones_Conversion(datos, new Date().getTime() + "_" + idDesignacion.toString());
      return this._db.put(nuevo)
        .then((resultado: PouchDB.Core.Response) => {
          if (resultado.ok) {
            nuevo._id = resultado.id;
            nuevo._rev = resultado.rev;
            nuevo.type = DBService._nombreTablaConfirmarAlineaciones;
            return Promise.resolve(nuevo);
          }
          else {
            return Promise.reject("No se ha podido guardar los datos de la confirmación.");
          }
        })
        .catch(error => Promise.reject(error));
    }

    /**
     * Elimina el registro de la base de datos, según los datos pasados como parámetros
     *
     * @param {number} idDesignacion    Identificador de la designación
     * @param {boolean} equipoLocal     Indica si es la confirmación del equipo local
     * @returns {Promise<boolean>}      Booleano
     * @memberof DBService
     */
    ConfirmarAlineaciones_Delete(idDesignacion: number, equipoLocal: boolean): Promise<boolean> {
      return this._db.find({
        selector: {
          type: DBService._nombreTablaConfirmarAlineaciones,
          idDesignacion: idDesignacion,
          equipoLocal: equipoLocal
        }
      })
        .then((resultado: PouchDB.Find.FindResponse<iActas_ConfirmarAlineaciones>) => {
          if (resultado.docs != null && resultado.docs.length > 0) {
            let aux: Array<Promise<PouchDB.Core.Response>> = [];

            resultado.docs.forEach((valor: PouchDB.Core.Document<iActas_ConfirmarAlineaciones>, i: number) => {
              aux.push(this._db.remove(valor._id, valor._rev));
            });
            return Promise.all(aux);
          }
        })
        .then((resultado) => {
          return Promise.resolve(true);
        })
        .catch(error => Promise.reject(error));
    }

    /**
    *  Obtiene los datos de la confirmación de la alineación, según la designación y si es el equipo local
     *
     * @param {number} idDesignacion  Identificador de la designación
     * @param {boolean} equipoLocal   Indica si es el equipo local
     * @returns {(Promise<iActas_ConfirmarAlineaciones | undefined>)}
     * @memberof DBService
     */
    ConfirmarAlineaciones_GetByDesignacion(idDesignacion: number, equipoLocal: boolean): Promise<iActas_ConfirmarAlineaciones | undefined> {
      return this._db.find({
        selector: {
          type: DBService._nombreTablaConfirmarAlineaciones,
          idDesignacion: idDesignacion,
          equipoLocal: equipoLocal
        }
      })
        .then((resultado: PouchDB.Find.FindResponse<iActas_ConfirmarAlineaciones>) => {
          let datos: iActas_ConfirmarAlineaciones = undefined;
          if (resultado.docs != null && resultado.docs.length > 0) {
            datos = resultado.docs[0];
          }
          return Promise.resolve(datos);
        })
        .catch((error) => Promise.reject(error));
    }

    /**
     * Actualiza los datos de la confirmación de alineación pasados como parámetros
     *
     * @param {iActas_ConfirmarAlineaciones} datos    Datos a actualizar
     * @returns {Promise<iActas_ConfirmarAlineaciones>}   Registro actualizado
     * @memberof DBService
     */
    ConfirmarAlineaciones_Update(datos: iActas_ConfirmarAlineaciones): Promise<iActas_ConfirmarAlineaciones> {
      return this._db.get(datos._id)
        .then((resultado: PouchDB.Core.GetMeta) => {
          datos._rev = resultado._rev;

          return this._db.put(datos)
        })
        .then((resultado: PouchDB.Core.Response) => {
          if (resultado.ok) {
            datos._id = resultado.id;
            datos._rev = resultado.rev;
            datos.type = DBService._nombreTablaConfirmarAlineaciones;
            return Promise.resolve(datos);
          }
          else {
            return Promise.reject("No se ha realizado la actualización de la confirmación de la alineación.");
          }
        })
        .catch(error => Promise.reject(error));
    }

    // #endregion

    // #region CUSTODIAS_V2

    /**
     * Convierte los datos de la custodia a un registro para guardar en la BD, del tipo CUSTODIA_V2
     * @param datos Datos de la custodia
     */
    CustodiaV2_Conversion(datos: ActaCustodiaMin, _id: string = '', _rev: string = ''): iActaCustodiaMin {
      let nuevo: iActaCustodiaMin = <iActaCustodiaMin>datos;
      nuevo._id = _id;
      nuevo._rev = _rev;
      nuevo.type = DBService._nombreTablaCustodias;
      return nuevo;
    }

    /**
     * Guarda en la base de datos un registro con los datos de la custodia pasada como parámetro
     * @param datos Datos de la custodia
     */
    CustodiaV2_Create(datos: ActaCustodiaMin, idDesignacion: number): Promise<iActaCustodiaMin> {
      let nuevo: iActaCustodiaMin = this.CustodiaV2_Conversion(datos, new Date().getTime() + "_" + idDesignacion.toString());
      return this._db.put(nuevo)
        .then((resultado: PouchDB.Core.Response) => {
          if (resultado.ok) {
            nuevo._id = resultado.id;
            nuevo._rev = resultado.rev;
            nuevo.type = DBService._nombreTablaCustodias;
            return Promise.resolve(nuevo);
          }
          else {
            return Promise.reject("No se ha podido guardar los datos de la custodia.");
          }
        })
        .catch(error => Promise.reject(error));
    }

    /**
     * Elimina cualquier registro de custodia asociado con la designación cuyo identificador es pasado como parámetro
     * @param idDesignacion Identificador de la designación asociada a la custodia
     */
    CustodiaV2_Delete(idDesignacion: number): Promise<boolean> {
      return this._db.find({
        selector: {
          type: DBService._nombreTablaCustodias,
          idDesignacion: idDesignacion
        }
      })
        .then((resultado: PouchDB.Find.FindResponse<iActaCustodiaMin>) => {
          if (resultado.docs != null && resultado.docs.length > 0) {
            let aux: Array<Promise<PouchDB.Core.Response>> = [];

            resultado.docs.forEach((valor: PouchDB.Core.Document<iActaCustodiaMin>, i: number) => {
              aux.push(this._db.remove(valor._id, valor._rev));
            });
            return Promise.all(aux);
          }
        })
        .then((resultado) => {
          return Promise.resolve(true);
        })
        .catch(error => {
          return Promise.reject(error);
        });
    }

    /**
     * Obtiene el primer registro de la base de datos, tabla CUSTODIA_V2 relacionada con la designación pasada como parámetro
     * @param idDesignacion Identificador de la designación asociada a la custodia
     */
    CustodiaV2_GetByDesignacion(idDesignacion: number): Promise<iActaCustodiaMin | undefined> {
      return this._db.find({
        selector: {
          type: DBService._nombreTablaCustodias,
          idDesignacion: idDesignacion
        }
      })
        .then((resultado: PouchDB.Find.FindResponse<iActaCustodiaMin>) => {
          let datos: iActaCustodiaMin = undefined;
          if (resultado.docs != null && resultado.docs.length > 0) {
            datos = resultado.docs[0];
          }
          return Promise.resolve(datos);
        })
        .catch((error) => Promise.reject(error));
    }

    /**
     * Actualiza en la base de datos, la custodia pasada como parámetro. Es importante primero obtener el registro mediante su _id, luego actualizar el valor de _rev y por último guardar el registro actual.
     * @param datos Datos de la custodia
     */
    CustodiaV2_Update(datos: iActaCustodiaMin): Promise<iActaCustodiaMin> {
      return this._db.get(datos._id)
        .then((resultado: PouchDB.Core.GetMeta) => {
          datos._rev = resultado._rev;

          return this._db.put(datos)
        })
        .then((resultado: PouchDB.Core.Response) => {
          if (resultado.ok) {
            datos._id = resultado.id;
            datos._rev = resultado.rev;
            datos.type = DBService._nombreTablaCustodias;
            return Promise.resolve(datos);
          }
          else {
            return Promise.reject("No se ha realizado la actualización de la custodia");
          }
        })
        .catch(error => Promise.reject(error));
    }

    // #endregion

    //#region CUSTODIAS

    CustodiaConversion(datos: ActaCustodiaMin): iActaCustodiaMin {
      let nuevo: iActaCustodiaMin = <iActaCustodiaMin>datos;
      nuevo._id = '';
      nuevo._rev = '';
      nuevo.type = 'CUSTODIAS';
      return nuevo;
    }

    CustodiaCreate(datos: ActaCustodiaMin): Promise<PouchDB.Core.Response> {
      let nuevo: iActaCustodiaMin = this.CustodiaConversion(datos);
      nuevo._id = new Date().getTime() + "_" + nuevo.idDesignacion.toString();
      nuevo._rev = '';
      nuevo.type = 'CUSTODIAS';
      return this._db.put(nuevo);
    }

    CustodiaDelete(idDesignacion: number): Promise<boolean> {
      return this._db.find({
        selector: {
          type: 'CUSTODIAS',
          idDesignacion: idDesignacion
        }
      })
        .then((resultado: PouchDB.Find.FindResponse<iActaCustodiaMin>) => {
          if (resultado.docs != null && resultado.docs.length > 0) {
            let aux: Array<Promise<PouchDB.Core.Response>> = [];

            resultado.docs.forEach((valor: PouchDB.Core.Document<iActaCustodiaMin>, i: number) => {
              aux.push(this._db.remove(valor._id, valor._rev));
            });
            return Promise.all(aux);
          }
        })
        .then((resultado) => {
          return Promise.resolve(true);
        })
        .catch((error) => {
          return Promise.reject(error);
        })
    }

    CustodiaGetByDesignacion(idDesignacion: number): Promise<PouchDB.Find.FindResponse<any>> {
      return this._db.find({
        selector: {
          type: 'CUSTODIAS',
          idDesignacion: idDesignacion
        }
      });
    }

    /**
     * Actualiza en la BD los datos de la custodia pasada como parámetro. Es importante primero obtener el registro mediante su _id, luego actualizar el valor de _rev y por último guardar el registro actual.
     * @param datos Datos de la custodia a actualizar
     */
    CustodiaUpdate(datos: iActaCustodiaMin): Promise<iActaCustodiaMin> {
      return this._db.get(datos._id)
        .then((resultado: PouchDB.Core.GetMeta) => {
          datos._rev = resultado._rev;

          return this._db.put(datos)
        })
        .then((resultado: PouchDB.Core.Response) => {
          if (resultado.ok) {
            datos._id = resultado.id;
            datos._rev = resultado.rev;
            return Promise.resolve(datos);
          }
          else {
            return Promise.reject("No se ha realizado la actualización de la custodia");
          }
        })
        .catch(error => Promise.reject(error));
    }

    //#endregion

    // #region DESIGNACIONES

    DesignacionesConversion(datos: Designaciones_API, idUsuario: number): iDesignacionesAPI {
      let nuevo: iDesignacionesAPI = <iDesignacionesAPI>datos;
      nuevo._id = '';
      nuevo._rev = '';
      nuevo.type = 'DESIGNACIONES';
      nuevo.idUsuario = idUsuario;
      return nuevo;
    }

    DesignacionesCreateAll(datos: Array<Designaciones_API>, idUsuario: number): Promise<PouchDB.Core.Response[]> {
      let aux: Array<Promise<PouchDB.Core.Response>> = [];

      datos.forEach((valor: Designaciones_API, i: number) => {
        let nuevo: iDesignacionesAPI = this.DesignacionesConversion(valor, idUsuario);

        nuevo._id = new Date().getTime() + '_' + nuevo.id_Designacion.toString();
        nuevo._rev = '';
        nuevo.type = 'DESIGNACIONES';
        aux.push(this._db.put(nuevo));
      });
      return Promise.all(aux);
    }

    /**
     * Elimina el registro de la designación cuyo identificador es pasado como parámetro
     * @param id_Designacion Identificador de la designación
     */
    DesignacionDelete(id_Designacion): Promise<boolean> {
      return this._db.find({
        selector: {
          type: 'DESIGNACIONES',
          id_Designacion: id_Designacion
        }
      })
        .then((resultado: PouchDB.Find.FindResponse<iDesignacionesAPI>) => {
          if (resultado.docs != null && resultado.docs.length > 0) {
            let aux: Array<Promise<PouchDB.Core.Response>> = [];

            resultado.docs.forEach((valor: PouchDB.Core.Document<iDesignacionesAPI>, i: number) => {
              aux.push(this._db.remove(valor._id, valor._rev));
            });
            return Promise.all(aux);
          }
        })
        .then((resultado) => {
          return Promise.resolve(true);
        })
        .catch((error) => {
          return Promise.reject(error);
        });
    }

    DesignacionesGetAll(): Promise<PouchDB.Find.FindResponse<any>> {
      return this._db.find({
        selector: {
          type: 'DESIGNACIONES'
        }
      });
    }

    DesignacionesGetByUser(idUsuario: number): Promise<PouchDB.Find.FindResponse<any>> {
      return this._db.find({
        selector: {
          type: 'DESIGNACIONES',
          idUsuario: idUsuario
        }
      });
    }

    DesignacionesGetById(idUsuario: number, idDesignacion: number): Promise<undefined | iDesignacionesAPI> {
      return this._db.find({
        selector: {
          type: 'DESIGNACIONES',
          idUsuario: idUsuario,
          id_Designacion: idDesignacion
        }
      })
        .then((resultado: PouchDB.Find.FindResponse<iDesignacionesAPI>) => {
          let datos: iDesignacionesAPI = undefined;
          if (resultado.docs != null && resultado.docs.length > 0) {
            datos = resultado.docs[0];
          }
          return Promise.resolve(datos);
        })
        .catch(error => Promise.reject("ERROR: " + JSON.stringify(error)));
    }

    /**
     * Actualiza en la BD los datos de la designación pasada como parámetro. Es importante primero obtener el registro mediante su _id, luego actualizar el valor de _rev y por último guardar el registro actual.
     * @param datos Datos de la designación a actualizar
     */
    DesignacionesUpdate(datos: iDesignacionesAPI): Promise<PouchDB.Core.Response> {
      return this._db.get(datos._id)
        .then((resultado: PouchDB.Core.GetMeta) => {
          datos._rev = resultado._rev;

          return this._db.put(datos);
        })
        .catch(error => Promise.reject(error));
    }

    // #endregion

    // #region FOTOS

    FotosConversion(datos: Images_Value): iFotos {
      let nuevo: iFotos = <iFotos>datos;
      nuevo._id = '';
      nuevo._rev = '';
      nuevo.type = 'FOTOS';
      return nuevo;
    }

    FotosCreate(datos: Images_Value): Promise<PouchDB.Core.Response> {
      let nuevo: iFotos = this.FotosConversion(datos);

      nuevo._id = new Date().getTime() + '_' + nuevo.idJugador.toString();

      return this._db.put(nuevo);
    }

    FotosDeleteAll(): Promise<boolean> {
      return this._db.find({
        selector: {
          type: 'FOTOS'
        }
      })
        .then((resultado: PouchDB.Find.FindResponse<iFotos>) => {
          if (resultado.docs != null && resultado.docs.length > 0) {
            let aux: Array<Promise<PouchDB.Core.Response>> = [];

            resultado.docs.forEach((valor: PouchDB.Core.Document<iFotos>, i: number) => {
              aux.push(this._db.remove(valor._id, valor._rev));
            });

            return Promise.all(aux);
          }
        })
        .then(() => {
          return Promise.resolve(true);
        })
        .catch(() => {
          return Promise.reject(false);
        });
    }

    FotosPorJugador(idJugador: number): Promise<PouchDB.Find.FindResponse<any>> {
      return this._db.find({
        selector: {
          type: 'FOTOS',
          idJugador: idJugador
        }
      });
    }

    // #endregion

    // #region LICENCIAS

    LicenciasConversion(datos: LicenciasPorEquipo_Value): iLicencias {
      let nuevo: iLicencias = <iLicencias>datos;
      nuevo._id = '';
      nuevo._rev = '';
      nuevo.type = "LICENCIAS";
      return nuevo;
    }

    LicenciasCreate(datos: LicenciasPorEquipo_Value): Promise<PouchDB.Core.Response> {
      let nuevo: iLicencias = this.LicenciasConversion(datos);

      nuevo._id = new Date().getTime() + '_' + nuevo.idEquipo.toString() + '_' + nuevo.id_Designacion.toString();
      nuevo._rev = "";
      nuevo.type = "LICENCIAS";

      return this._db.put(nuevo);
    }

    LicenciasDeleteAll(): Promise<boolean> {
      return this._db.find({
        selector: {
          type: 'LICENCIAS'
        }
      })
        .then((resultado: PouchDB.Find.FindResponse<iLicencias>) => {
          if (resultado.docs != null && resultado.docs.length > 0) {
            let aux: Array<Promise<PouchDB.Core.Response>> = [];

            resultado.docs.forEach((valor: PouchDB.Core.Document<iLicencias>, i: number) => {
              aux.push(this._db.remove(valor._id, valor._rev));
            });

            return Promise.all(aux);
          }
        })
        .then(() => {
          return Promise.resolve(true);
        })
        .catch(() => {
          return Promise.reject(false);
        });
    }

    LicenciasDeleteByDesignacion(id_Designacion: number): Promise<boolean> {
      return this._db.find({
        selector: {
          type: 'LICENCIAS',
          id_Designacion: id_Designacion
        }
      })
        .then((resultado: PouchDB.Find.FindResponse<iLicencias>) => {
          if (resultado.docs != null && resultado.docs.length > 0) {
            let aux: Array<Promise<PouchDB.Core.Response>> = [];

            resultado.docs.forEach((valor: PouchDB.Core.Document<iLicencias>, i: number) => {
              aux.push(this._db.remove(valor._id, valor._rev));
            });

            return Promise.all(aux);
          }
        })
        .then(() => {
          return Promise.resolve(true);
        })
        .catch(() => {
          return Promise.reject(false);
        });
    }

    LicenciasPorDesignacion(idDesignacion: number): Promise<PouchDB.Find.FindResponse<any>> {
      return this._db.find({
        selector: {
          type: 'LICENCIAS',
          id_Designacion: idDesignacion
        }
      });
    }

    LicenciasPorDesignacionYEquipo(idDesignacion: number, idEquipo: number): Promise<PouchDB.Find.FindResponse<any>> {
      return this._db.find({
        selector: {
          type: 'LICENCIAS',
          id_Designacion: idDesignacion,
          idEquipo: idEquipo
        }
      });
    }

    // #endregion

    // #region LOGS

    /**
     * Guarda un registro Log con los datos pasados como parámetros
     * @param datos Datos del Log a guardar
     */
    CrearLog(datos: iLogs): Promise<iLogs> {
      datos._id = new Date().getTime().toString() + "_" + datos.controlador + "_" + datos.metodo;
      datos._rev = "";
      datos.type = DBService._nombreTableLogs;

      return this._db.put(datos)
        .then((resultado: PouchDB.Core.Response) => {
          if (resultado.ok) {
            datos._id = resultado.id;
            datos._rev = resultado.rev;
            datos.type = DBService._nombreTableLogs;
            return Promise.resolve(datos);
          }
          else {
            return Promise.reject("No se ha podido guardar el LOG en la Base de datos.");
          }
        })
        .catch(error => Promise.reject(error));
    }

    /**
     * Elimina todos los registros de LOGS de la base de datos
     */
    EliminarTodosLogs(): Promise<boolean> {
      return this._db.find({
        selector: {
          type: DBService._nombreTableLogs
        }
      })
        .then((resultado: PouchDB.Find.FindResponse<iLogs>) => {
          if (resultado.docs != null && resultado.docs.length > 0) {
            let aux: Array<Promise<PouchDB.Core.Response>> = [];

            resultado.docs.forEach((valor: PouchDB.Core.Document<iLogs>, i: number) => {
              aux.push(this._db.remove(valor._id, valor._rev));
            });

            return Promise.all(aux);
          }
        })
        .then(() => {
          return Promise.resolve(true);
        })
        .catch(() => {
          return Promise.reject(false);
        });
    }

    /**
     * Obtiene la lista completa de los Logs guardados en la aplicación
     */
    ObtenerLogs(): Promise<Array<iLogs>> {
      return this._db.find({
        selector: {
          type: DBService._nombreTableLogs
        }
      })
        .then((resultado: PouchDB.Find.FindResponse<iLogs>) => {
          let datos: Array<iLogs> = [];
          if (resultado != null && resultado.docs != null && resultado.docs.length > 0) {
            resultado.docs.forEach((valor: PouchDB.Core.ExistingDocument<iLogs>) => {
              datos.push(valor);
            });
          }
          return Promise.resolve(datos);
        })
        .catch(error => {
          console.log(error);
          return Promise.reject(error)
        });
    }

    // #endregion

    //#region TIPOS DE LICENCIAS

    TiposLicenciasConversion(datos: TipoLicenciaMin): iTipoLicenciaMin {
      let nuevo: iTipoLicenciaMin = <iTipoLicenciaMin>datos;
      nuevo._id = '';
      nuevo._rev = '';
      nuevo.type = 'TIPOSLICENCIAS';
      return nuevo;
    }

    TiposLicenciasCreateAll(datos: Array<TipoLicenciaMin>): Promise<PouchDB.Core.Response[]> {
      let aux: Array<Promise<PouchDB.Core.Response>> = [];

      datos.forEach((valor: TipoLicenciaMin, i: number) => {
        let nuevo: iTipoLicenciaMin = this.TiposLicenciasConversion(valor);

        nuevo._id = new Date().getTime() + '_' + nuevo.id.toString();

        aux.push(this._db.put(nuevo));
      });

      return Promise.all(aux);
    }

    TiposLicenciasDeleteAll(): Promise<boolean> {
      return this._db.find({
        selector: {
          type: 'TIPOSLICENCIAS'
        }
      })
        .then((resultado: PouchDB.Find.FindResponse<iTipoLicenciaMin>) => {
          if (resultado.docs != null && resultado.docs.length > 0) {
            let aux: Array<Promise<PouchDB.Core.Response>> = [];

            resultado.docs.forEach((valor: PouchDB.Core.Document<iTipoLicenciaMin>, i: number) => {
              aux.push(this._db.remove(valor._id, valor._rev));
            });

            return Promise.all(aux);
          }
        })
        .then((resultado) => {
          return Promise.resolve(true);
        })
        .catch((error) => {
          return Promise.reject(false);
        });
    }

    TiposLicenciasGetAll(): Promise<PouchDB.Find.FindResponse<any>> {
      return this._db.find({
        selector: {
          type: 'TIPOSLICENCIAS'
        }
      });
    }

    //#endregion

    // #region USUARIOS

    UsuariosConversion(datos: Arbitros): iArbitros {
      let nuevo: iArbitros = <iArbitros>datos;
      nuevo._id = '';
      nuevo._rev = '';
      nuevo.type = 'USUARIOS';
      return nuevo;
    }

    UsuariosCreate(datos: iArbitros): Promise<PouchDB.Core.Response> {
      // Actualización del usuario y el email a maýusculas, para que en la búsqueda no haya problemas de no encontrar el usuario
      if (datos.email != null) {
        datos.email = datos.email.toUpperCase();
      }
      if (datos.usuario != null) {
        datos.usuario = datos.usuario.toUpperCase();
      }

      if (datos._id == '') {
        datos._id = new Date().getTime() + '';
      }

      return this._db.put(datos);
    }

    UsuariosDelete(id: string, rev: string): Promise<PouchDB.Core.Response> {
      return this._db.remove(id, rev);
    }

    UsuariosGetAll(): Promise<PouchDB.Find.FindResponse<any>> {
      return this._db.find({
        selector: {
          type: 'USUARIOS'
        }
      });
    }

    UsuariosGetById(idUsuario: number): Promise<PouchDB.Find.FindResponse<any>> {
      return this._db.find({
        selector: {
          idUsuario: { $eq: idUsuario },
          type: 'USUARIOS'
        }
      });
    }

    UsuariosGetByUsuarioYPassword(usuario: string, password: string): Promise<PouchDB.Find.FindResponse<any>> {
      return this._db.find({
        selector: {
          usuario: { $eq: usuario.toUpperCase() },
          password: { $eq: password },
          type: 'USUARIOS'
        }
      })
        .then(response => {
          if (response.docs != null && response.docs.length > 0) {
            return response;
          }
          else {
            return null;
          }
        });
    }

    /**
     * Actualiza los datos del usuario. Es importante primero obtener el registro mediante su _id, luego actualizar el valor de _rev y después guardar el registro actualizado.
     * @param datos Datos del usuario a actualizar
     */
    UsuariosUpdate(datos: iArbitros): Promise<PouchDB.Core.Response> {
      return this._db.get(datos._id)
        .then((resultado: PouchDB.Core.GetMeta) => {
          datos._rev = resultado._rev;

          return this._db.put(datos);
        })
        .catch(error => Promise.reject(error));
    }

    // #endregion
  }
}

// #endregion

// #region pouchdb VERSIÓN 2

export namespace pouchdb2 {

  // #region Interfaces genéricos
  export interface IRegistroDB {
    _id: string;
    _rev: string;
    type: string;
  }
  // #endregion

  // #region Clases genéricas
  export class RegistroDB implements IRegistroDB {
    public _id: string;
    public _rev: string;
    public type: string;
    public urlApi: string;
    public urlNombre: string;

    constructor(nombreTabla: string, id: number) {
      if (nombreTabla.trim().length > 0 && id > 0) {
        this._id = new Date().getTime() + '_' + id.toString();
        this._rev = "";
        this.type = nombreTabla.trim();
        this.urlApi = "";
        this.urlNombre = "";
      }
      else {
        this._id = "";
        this._rev = "";
        this.type = "";
        this.urlNombre = "";
        this.urlApi = "";
      }
    }
  }
  // #endregion

  // #region Clases envolventes

  export class ActasAmonestacionesDB extends RegistroDB implements Online.IActas_Amonestaciones_Base {
    // #region Propiedades
    public idAmonestacion: number;
    public idDesignacion: number;
    public idEquipo: number;
    public idJugador: number;
    public amonestacion: number;
    public anexo: string;
    public esIncidencia: boolean;
    public minuto: string;
    public minutoExtra: string;
    // #endregion

    constructor(nombreTabla: string, _idAmonestacion: number) {
      super(nombreTabla, _idAmonestacion);
      this.idAmonestacion = _idAmonestacion;
    }
  }

  export class ActasCambiosDB extends RegistroDB implements Online.IActas_Cambios_Base {
    // #region Propiedades
    public idCambio: number;
    public idDesignacion: number;
    public idEquipo: number;
    public entra: number;
    public sale: number;
    public minuto: string;
    public ventana: number;
    public descanso: boolean;
    public minutoExtra: string;
    // #endregion

    constructor(nombreTabla: string, _idCambio: number) {
      super(nombreTabla, _idCambio);
      this.idCambio = _idCambio;
    }
  }

  export class ActasCodigosAmonestacionDB extends RegistroDB implements Online.IActas_Codigos_Amonestacion {
    // #region Propiedades
    public Id: number;
    public EsAmonestacion: boolean;
    public EsExpulsion: boolean;
    public Codigo: number;
    public Hecho: string;
    public TieneAnexo: boolean;
    public noParticipante: boolean;
    // #endregion

    constructor(nombreTabla: string, _id: number) {
      super(nombreTabla, _id);
      this.Id = _id;
    }
  }

  export class ActasConfirmacionDB extends RegistroDB implements Online.IActa_ConfirmarAlineacion {
    // #region Propiedades
    public idRegistro: number;
    public idDesignacion: number;
    public idActa: number;
    public idCalendario: number;
    public idEquipo: number;
    public idLicencia: number;
    public equipoLocal: boolean;
    public firma: string;
    // #endregion

    constructor(nombreTabla: string, _idRegistro: number) {
      super(nombreTabla, _idRegistro);
      this.idRegistro = _idRegistro;
    }
  }

  export class ActasCustodiaDB extends RegistroDB implements Online.IActa_Custodia {
    // #region Propiedades
    public id: number;
    public idDesignacion: number;
    public entregada: boolean;
    public renuncia: boolean;
    public idTablet: string;
    public nombre: string;
    public apellidos: string;
    public dni: string;
    public cargo: string;
    public idClub: number;
    public firma: string;
    public aceptaResponsabilidad: boolean;
    public fechaEntrega: Date;
    public fechaDevolucion: Date | null;
    public sinIncidencias: boolean;
    public recogida: boolean;
    public textoIncidencias: string;
    // #endregion

    constructor(nombreTabla: string, _id: number) {
      super(nombreTabla, _id);
      this.id = _id;
    }
  }

  export class ActasConfiguracionesDB extends RegistroDB implements Online.IActa_Configuraciones {
    // #region Propiedades
    public idDesignacion: number;
    public esFutbolSala: boolean;
    public esFutbolPlaya: boolean;
    public nArbitros: number;
    public nAsistentes: number;
    public cronometrador: boolean;
    public nJugadoresEnActa: number;
    public nTitulares: number;
    public nMaximoSustituciones: number;
    public auxiliaresFutbolBase: boolean;
    public futbolVeterano: boolean;
    public obligadaParticipacion: boolean;
    public proyectoGanar: boolean;
    // #endregion

    constructor(nombreTabla: string, _idDesignacion: number) {
      super(nombreTabla, _idDesignacion);
      this.idDesignacion = _idDesignacion;
    }
  }

  export class ActasDerechosDB extends RegistroDB implements Online.IActa_Derechos {
    // #region Propiedades
    public idDerechos: number;
    public idDesignacion: number;
    public tarifaL: number;
    public tarifaV: number;
    public transporteL: number;
    public transporteV: number;
    public dietasL: number;
    public dietasV: number;
    public avionL: number;
    public avionV: number;
    public otrosL: number;
    public otrosV: number;
    public abonaTarifaL: boolean;
    public abonaTarifaV: boolean;
    public abonaOtrosL: boolean;
    public abonaOtrosV: boolean;
    public unificado: boolean;
    public compartido: boolean;
    public desdeBancoL: boolean;
    public desdeBancoV: boolean;
    public pagoRealizadoL: boolean;
    public pagoRealizadoV: boolean;
    // #endregion

    constructor(nombreTabla: string, _idDesignacion: number) {
      super(nombreTabla, _idDesignacion);
      this.idDesignacion = _idDesignacion;
    }
  }

  export class ActasFutbolSalaDB extends RegistroDB implements Online.IActa_FutbolSala {
    // #region Propiedades
    public idRegistro: number;
    public idDesignacion: number;
    public faltasLocal1Parte: number;
    public faltasLocal2Parte: number;
    public faltasVisitante1Parte: number;
    public faltasVisitante2Parte: number;
    public tiempoMuertoLocal1Parte: boolean;
    public tiempoMuertoLocal2Parte: boolean;
    public tiempoMuertoVisitante1Parte: boolean;
    public tiempoMuertoVisitante2Parte: boolean;
    // #endregion

    constructor(nombreTabla: string, _idRegistro: number) {
      super(nombreTabla, _idRegistro);
      this.idRegistro = _idRegistro;
    }
  }

  export class ActasGolesDB extends RegistroDB implements Online.IActa_Goles_Base {
    // #region Propiedades
    public idGol: number;
    public idDesignacion: number;
    public idEquipo: number;
    public idJugador: number;
    public minuto: string;
    public propiaPuerta: boolean;
    public penalty: boolean;
    public minutoExtra: string;
    // #endregion

    constructor(nombreTabla: string, _idGol: number) {
      super(nombreTabla, _idGol);
      this.idGol = _idGol;
    }
  }

  export class ActasOtrosDB extends RegistroDB implements Online.IActasOtros {
    // #region Propiedades
    public idRegistro: number;
    public idDesignacion: number;
    public versionCFutbolActas: string;
    public alineacionesTerminadas: boolean;
    public actaCerrada: boolean;
    public hora1Parte: string;
    public hora2Parte: string;
    public resultado1Parte: string;

    public idEstadoProvisional: number;
    public estadoProvisional: string;

    public incidentes: string;
    public incidenciasNoModificables: string;
    public comentarios: string;
    public noFirmaDelegadoLocal: boolean;
    public noFirmaDelegadoVisitante: boolean;
    public reactivaciones: string;
    public fuerzaPublica: boolean;
    public motivoSuspension: string;

    public golLocalParcial?: number;
    public golVisitanteParcial?: number;

    public dobleFuncionDelegado: boolean;
    public delegadosDistintos: boolean;
    public noExisteDelegadoCampo: boolean;
    public noExisteDelegadoEquipoLocal: boolean;
    public noExisteDelegadoEquipoVisitante: boolean;

    public confirmacionParticipantes: boolean;

    public motivoSuspendidoNoIniciado: string;

    public presentaEntrenadorLocal?: boolean;
    public presentaEntrenadorVisitante?: boolean;

    public minutoSuspension?: number;    // Minuto en el que se produjo la suspensión del encuentro
    public golesLocalSuspendido?: number;  // Goles del equipo local cuando se produjo la suspensión
    public golesVisitanteSuspendido?: number;  // Goles del equipo visitante cuando se produjo la suspensión
    // #endregion

    constructor(nombreTabla: string, _idRegistro: number) {
      super(nombreTabla, _idRegistro);
      this.idRegistro = _idRegistro;
    }
  }

  export class ActasParticipacionDB extends RegistroDB implements Online.IActa_Participacion {
    // #region Propiedades
    public idRegistro: number;
    public idDesignacion: number;
    public idEquipo: number;
    public idAlineado: number;
    public identificador: string;
    public dorsal: number
    public esTitular: boolean;
    public esSuplente: boolean;
    public esCapitan: boolean;
    public esEntrenador: boolean;
    public esDelegado: boolean;
    public esDelegadoCampo: boolean;
    public participa: boolean;
    public enQuintetoFinal1: boolean;
    public enQuintetoFinal2: boolean;
    public minutoCambio: string;
    // #endregion

    constructor(nombreTabla: string, _idRegistro: number) {
      super(nombreTabla, _idRegistro);
      this.idRegistro = _idRegistro;
      this.idDesignacion = 0;
      this.idEquipo = 0;
      this.idAlineado = 0;
      this.identificador = "";
      this.dorsal = 0;
      this.esTitular = false;
      this.esSuplente = false;
      this.esCapitan = false;
      this.esEntrenador = false;
      this.esDelegado = false;
      this.esDelegadoCampo = false;
      this.participa = false;
      this.enQuintetoFinal1 = false;
      this.enQuintetoFinal2 = false;
    }
  }

  export class ArbitroBasicoDB extends RegistroDB implements Online.IArbitro {
    // #region Propiedades
    public idArbitro: number;
    public nombre: string;
    public apellido1: string;
    public apellido2: string;
    public numero: number;
    public activo: boolean;
    public firma: string;
    public usuario: string;
    public contrasenia: string;
    // #endregion

    constructor(nombreTabla: string, _idArbitro: number) {
      super(nombreTabla, _idArbitro);
      this.idArbitro = _idArbitro;
    }
  }

  export class DesignacionDB extends RegistroDB implements Online.IDesignacion, Online.IArbitro, Online.IPartido {

    // #region Propiedades

    // Interfaz: IDesignacion
    public idDesignacion: number;
    public idComite: number;
    public descargado: boolean;
    public realizado: boolean;
    public fechaDescarga: string;
    public fechaRealizado: string;
    public nuevosDerechosArbitrales: boolean;
    public cFutbolActas: boolean;
    public emailArbitro: string;
    public arbitro2?: string;
    public asistente1?: string;
    public asistente2?: string;
    public asistente3?: string;
    public asistente4?: string;
    public cronometrador?: string;

    // Interfaz: IArbitro
    public idArbitro: number;
    public nombre: string;
    public apellido1: string;
    public apellido2: string;
    public numero: number;
    public activo: boolean;
    public firma: string;
    public usuario: string;
    public contrasenia: string;

    // Interfaz: IPartido
    public idCalendario: number;
    public idCompeticion: number;
    public competicion: number;
    public grupo: number;
    public jornada: number;
    public ronda: number;
    public modificado: boolean;
    public fecha: string;
    public hora: string;
    public idLocal: number;
    public local: string;
    public idVisitante: number;
    public visitante: string;
    public estado: string;
    public campo: string;
    public sinHojaAlineacion: boolean;

    // Ventanas de cambios
    public ventanasCambios: boolean;
    public numeroVentanas: number;
    public numeroMaxCambios: number;
    public numeroMaxCambiosPorVentana: number;

    // Bloqueo
    public bloqueada: boolean;   // Indicará si la designación ha sido bloqueada (Positivos COVID)

    // #endregion

    constructor(nombreTabla: string, _idDesignacion: number) {
      super(nombreTabla, _idDesignacion);
      this.idDesignacion = _idDesignacion;
      this.bloqueada = false;
    }
  }

  export class PersonasAlineablesDB extends RegistroDB implements Online.IPersonaAlineable {
    // #region Propiedades
    public apellido1: string;
    public apellido2: string;
    public categoria: string;
    public codigoBarras: string;
    public esNacional: boolean;
    public fechaNacimiento: string;
    public idAlineado: number;
    public idCategoria: number;
    public idEquipo: number;
    public idDesignacion: number;
    public idPersona: number;
    public idTipoLicencia: number;
    public identificador: string;
    public nombre: string;
    public puedeEnlazarse: boolean;
    public real: boolean;
    public tipoLicencia: string;
    public codigoTipoLicencia: string;
    public esAuxiliar: boolean;
    public esEntrenador: boolean;
    public sinLicencia: boolean;
    public idClub: number;
    public club: string;
    public equipo: string;
    public dorsal: number | null;
    // #endregion

    constructor(nombreTabla: string, _idDesignacion: number, _idPersona: number, _idEquipo: number) {
      super(nombreTabla, _idPersona);
      this.idDesignacion = _idDesignacion;
      this.idEquipo = _idEquipo;
      this.idPersona = _idPersona;
    }
  }

  // #endregion

  @Injectable()
  export class DBService2 {

    // #region Propiedades específicas de la clase
    private _db: PouchDB.Database;        // Instancia que contendrá la referencia a la base de datos
    // #endregion

    // #region Propiedades con los nombres de las tablas de la BD
    public static _TablaActasAmonestaciones: string = "ActasAmonestaciones";
    public static _TablaActasCambios: string = "ActasCambios";
    public static _TablaActasConfirmacion: string = "ActasConfirmacion";
    public static _TablaActasConfiguraciones: string = "ActasConfiguraciones";
    public static _TablaActasCustodia: string = "ActasCustodia";
    public static _TablaActasDerechos: string = "ActasDerechos";
    public static _TablaActasGoles: string = "ActasGoles";
    public static _TablaActasOtros: string = "ActasOtros";
    public static _TablaActasParticipacion: string = "ActasParticipacion";
    public static _TablaDesignaciones: string = "Designaciones";
    public static _TablaArbitros: string = "Arbitros";
    public static _TablaPersonasAlineables: string = "PersonasAlineables";
    public static _TablaAlineados: string = "Alineados";
    // #endregion

    // #region Métodos específicos para la creación y eliminación de la base de datos

    /**
     * Inicializa la base de datos
     */
    public initDB(): void {
      PouchDB.plugin(cordovaSqlitePlugin);
      PouchDB.plugin(PouchFind);
      //this._db = new PouchDB('CFutbolActas2.db', { adapter: 'cordova-sqlite' });
      this._db = new PouchDB('CFutbolActas2.db', { adapter: 'websql' });
      this._db.info()
        .then((resultado: any) => {
          console.log("Base de datos inicializada");
          console.log(resultado);
        })
        .catch(error => console.error(error));
    }

    /**
     * Elimina la base de datos y la vuelve a crear
     */
    public destroy(): Promise<void> {
      return this._db.destroy()
        .then(() => {
          return this.initDB();
        });
    }

    // #endregion

    // #region Métodos para Actas_Confirmaciones

    /**
     * Obtiene los datos de confirmación de alineación del acta (Actas_ConfirmacionAlineacion) relacionada con una designación
     * @param idDesignacion Identificador de la designación relacionada
     * @param idEquipo  Identificador del equipo
     */
    public Actas_ConfirmacionAlineacion(idDesignacion: number, idEquipo: number): Promise<ActasConfirmacionDB> {
      return this._db.find({
        selector: {
          idDesignacion: { $eq: idDesignacion },
          idEquipo: { $eq: idEquipo },
          type: DBService2._TablaActasConfirmacion
        }
      })
        .then(response => {
          if (response.docs != null && response.docs.length > 0) {
            return <ActasConfirmacionDB>response.docs[0];
          }
          else {
            return null;
          }
        });
    }

    // #endregion

    // #region Métodos para Actas_Configuraciones

    /**
     * Obtiene los datos de configuración del acta (Actas_Configuracion) relacionada con una designación
     * @param idDesignacion Identificador de la designación relacionada
     */
    public Actas_Configuraciones(idDesignacion: number): Promise<ActasConfiguracionesDB> {
      return this._db.find({
        selector: {
          idDesignacion: { $eq: idDesignacion },
          type: DBService2._TablaActasConfiguraciones
        }
      })
        .then(response => {
          if (response.docs != null && response.docs.length > 0) {
            return <ActasConfiguracionesDB>response.docs[0];
          }
          else {
            return null;
          }
        });
    }

    // #endregion

    // #region Métodos para Actas_Custodia

    public Actas_Custodia(idDesignacion: number): Promise<ActasCustodiaDB> {
      return this._db.find({
        selector: {
          idDesignacion: { $eq: idDesignacion },
          type: DBService2._TablaActasCustodia
        }
      })
        .then(response => {
          if (response.docs != null && response.docs.length > 0) {
            return <ActasCustodiaDB>response.docs[0];
          }
          else {
            return null;
          }
        });
    }

    public Actas_Custodia_Guardar(datos: ActasCustodiaDB): Promise<ActasCustodiaDB> {
      if (datos.type == undefined || datos.type == "") {
        datos = Object.assign(new ActasOtrosDB(DBService2._TablaActasCustodia, datos.id), datos);
      }

      return this._db.put(datos)
        .then((respuesta: PouchDB.Core.Response) => {
          if (respuesta.ok) {
            datos._id = respuesta.id;
            datos._rev = respuesta.rev;
            return Promise.resolve(datos);
          }
          else {
            return Promise.reject(null);
          }
        })
        .catch(error => Promise.reject(error));
    }

    // #endregion

    // #region Métodos para Actas_Derechos

    /**
     * Obtiene los derechos arbitrales del acta (Actas_Derechos) relacionada con una designación
     * @param idDesignacion Identificador de la designación relacionada
     */
    public Actas_Derechos(idDesignacion: number): Promise<ActasDerechosDB> {
      return this._db.find({
        selector: {
          idDesignacion: { $eq: idDesignacion },
          type: DBService2._TablaActasDerechos
        }
      })
        .then(response => {
          if (response.docs != null && response.docs.length > 0) {
            return <ActasDerechosDB>response.docs[0];
          }
          else {
            return null;
          }
        });
    }

    // #endregion

    // #region Métodos para ACTAS_OTROS (Otros datos de las actas)

    /**
     * Obtiene los otros datos del acta (Actas_Otros) relacionada con una designación
     * @param idDesignacion Identificador de la designación relacionada
     */
    public Actas_Otros_PorDesignacion(idDesignacion: number): Promise<ActasOtrosDB> {
      return this._db.find({
        selector: {
          idDesignacion: { $eq: idDesignacion },
          type: DBService2._TablaActasOtros
        }
      })
        .then(response => {
          if (response.docs != null && response.docs.length > 0) {
            return <ActasOtrosDB>response.docs[0];
          }
          else {
            return null;
          }
        });
    }

    /**
     * Guarda los otros datos de un acta
     * @param datos Otros datos del acta
     */
    public Actas_Otros_Guardar(datos: ActasOtrosDB): Promise<ActasOtrosDB> {
      if (datos.type == undefined || datos.type == "") {
        datos = Object.assign(new ActasOtrosDB(DBService2._TablaActasOtros, datos.idRegistro), datos);
      }

      return this._db.put(datos)
        .then((respuesta: PouchDB.Core.Response) => {
          if (respuesta.ok) {
            datos._id = respuesta.id;
            datos._rev = respuesta.rev;
            return Promise.resolve(datos);
          }
          else {
            return Promise.reject(null);
          }
        })
        .catch(error => Promise.reject(error));
    }

    // #endregion

    // #region Métodos para ACTAS_PARTICIPACION

    public Actas_Participacion_Guardar(datos: ActasParticipacionDB): Promise<ActasParticipacionDB> {
      if (datos.type == undefined || datos.type == "") {
        datos = Object.assign(new ActasParticipacionDB(DBService2._TablaActasOtros, datos.idRegistro), datos);
      }

      return this._db.put(datos)
        .then((respuesta: PouchDB.Core.Response) => {
          if (respuesta.ok) {
            datos._id = respuesta.id;
            datos._rev = respuesta.rev;
            return Promise.resolve(datos);
          }
          else {
            return Promise.reject(null);
          }
        })
        .catch(error => Promise.reject(error));
    }

    /**
     * Obtiene los otros datos del acta (Actas_Participacion) relacionada con una designación
     * @param idDesignacion Identificador de la designación relacionada
     */
    public Actas_Participacion_PorDesignacionYEquipo(idDesignacion: number, idEquipo: number): Promise<Array<ActasParticipacionDB>> {
      return this._db.find({
        selector: {
          idDesignacion: { $eq: idDesignacion },
          idEquipo: { $eq: idEquipo },
          type: DBService2._TablaActasParticipacion
        }
      })
        .then(response => {
          if (response.docs != null && response.docs.length > 0) {
            return <Array<ActasParticipacionDB>>response.docs;
          }
          else {
            return null;
          }
        });
    }

    // #endregion

    // #region Métodos para los ÁRBITROS (Usuarios validados en la aplicación)

    /**
     * Guarda los datos del árbitro pasado como parámetro
     * @param datos Datos del árbitro a guardar
     */
    public Arbitro_Guardar(datos: ArbitroBasicoDB): Promise<ArbitroBasicoDB> {
      if (datos.type == undefined || datos.type == "") {
        datos = Object.assign(new ArbitroBasicoDB(DBService2._TablaArbitros, datos.idArbitro), datos);
      }

      return this._db.put(datos)
        .then((respuesta: PouchDB.Core.Response) => {
          if (respuesta.ok) {
            datos._id = respuesta.id;
            datos._rev = respuesta.rev;
            return Promise.resolve(datos);
          }
          else {
            return Promise.reject(null);
          }
        })
        .catch(error => Promise.reject(error));
    }

    /**
     * Obtiene el árbitro cuyo usuario y contraseña son pasados como parámetros
     * @param usuario Nombre del usuario
     * @param contrasenia Contraseña
     */
    public Arbitro_PorUsuarioYContrasenia(usuario: string, contrasenia: string): Promise<ArbitroBasicoDB | null> {
      return this._db.find({
        selector: {
          usuario: { $eq: usuario.toUpperCase() },
          password: { $eq: contrasenia },
          type: DBService2._TablaArbitros
        }
      })
        .then(response => {
          if (response.docs != null && response.docs.length > 0) {
            return <ArbitroBasicoDB>response.docs[0];
          }
          else {
            return null;
          }
        });
    }

    // #endregion

    // #region Métodos para las DESIGNACIONES

    /**
     * Guarda la designación pasada como parámetro
     * @param datos Datos de la designación a guardar
     */
    public Designacion_Guardar(datos: DesignacionDB): Promise<DesignacionDB> {
      if (datos.type == undefined || datos.type == "") {
        datos = Object.assign(new DesignacionDB(DBService2._TablaDesignaciones, datos.idDesignacion), datos);
      }

      return this._db.put(datos)
        .then((respuesta: PouchDB.Core.Response) => {
          if (respuesta.ok) {
            datos._id = respuesta.id;
            datos._rev = respuesta.rev;
            return Promise.resolve(datos);
          }
          else {
            return Promise.reject(null);
          }
        })
        .catch(error => Promise.reject(error));
    }

    /**
     * Lista de designaciones actuales que tiene el árbitro indicado
     * @param idArbitro Identificador del árbitro
     */
    public Designaciones_PorArbitro(idArbitro: number): Promise<Array<DesignacionDB>> {
      return this._db.find({
        selector: {
          idArbitro: { $eq: idArbitro },
          type: DBService2._TablaDesignaciones
        }
      })
        .then((response: PouchDB.Find.FindResponse<DesignacionDB>) => {
          if (response.docs != null && response.docs.length > 0) {
            return Promise.resolve(response.docs);
          }
          else {
            return Promise.reject(null);
          }
        })
        .catch(error => Promise.reject(error));
    }
    // #endregion

    // #region Métodos para las PERSONAS ALINEABLES

    /**
     * Guarda la persona alineable pasada como parámetro
     * @param datos Datos de la persona alineable a guardar
     */
    public PersonaAlineable_Guardar(datos: PersonasAlineablesDB, idEquipo: number): Promise<PersonasAlineablesDB> {
      if (datos.type == undefined || datos.type == "") {
        datos = Object.assign(new PersonasAlineablesDB(DBService2._TablaPersonasAlineables, datos.idDesignacion, datos.idPersona, idEquipo), datos);
      }

      return this._db.put(datos)
        .then((respuesta: PouchDB.Core.Response) => {
          if (respuesta.ok) {
            datos._id = respuesta.id;
            datos._rev = respuesta.rev;
            return Promise.resolve(datos);
          }
          else {
            return Promise.reject(null);
          }
        })
        .catch(error => Promise.reject(error));
    }

    /**
     * Lista de personas alineables en una designación, en uno de los equipos de dicha designación
     * @param idDesignacion Identificador de la designación
     * @param idEquipo Identificador del equipo
     */
    public PersonasAlineables_PorDesignacionYEquipo(idDesignacion: number, idEquipo: number): Promise<Array<PersonasAlineablesDB>> {
      return this._db.find({
        selector: {
          idDesignacion: { $eq: idDesignacion },
          idEquipo: { $eq: idEquipo },
          type: DBService2._TablaPersonasAlineables
        }
      })
        .then((response: PouchDB.Find.FindResponse<PersonasAlineablesDB>) => {
          if (response.docs != null && response.docs.length > 0) {
            return Promise.resolve(response.docs);
          }
          else {
            return Promise.reject(null);
          }
        })
        .catch(error => Promise.reject(error));
    }

    // #endregion
  }
}

// #endregion



// WEBPACK FOOTER //
// ./src/services/pouchdb/pouchdb.service.ts